import React from 'react';
import {placeholderMediumTextStyles} from "../Style";

const NavigateCarInsurance = ({steps}) => {
    const classNames = (...classes) => classes.filter(Boolean).join(' ');

    return (<div className="lg-navigation-width" style={{paddingBottom:"40px"}}>
        <nav style={{paddingRight: '0', paddingLeft: '0'}} aria-label="Progress">
            {/* Horizontal divider with title */}
            <div style={{
                display: 'flex',
                alignItems: 'center',
                marginTop: '8px',
                marginBottom: '8px',
                minHeight: '20px',
                padding: window.innerWidth <= 768 ? '0 2.8%' : '0 7%'
            }}>
                <div style={{flex: 1, height: '1px', borderTop: '1px solid #1851A3'}}/>
                <span style={{
                    color: '#1851A3',
                    fontWeight: '700',
                    fontSize: window.innerWidth <= 768 ? '14px' : '16px',
                    fontFamily: 'Lato',
                    padding: '0 12px',
                    whiteSpace: 'nowrap'
                }}>
                    Car Insurance
                </span>
                <div style={{flex: 1, height: '1px', borderTop: '1px solid #1851A3'}}/>
            </div>
            <ol role="list" style={{display: 'grid', gridTemplateColumns: 'repeat(5, 1fr)', paddingLeft: '0'}}>
                {steps.map((step, index) => (
                    <li key={index}
                        style={{listStyle: 'none', margin: '0 3px', position: 'relative', textAlign: 'center'}}>
                        <div style={{...placeholderMediumTextStyles, display: "flex", flexDirection: 'column'}}>
                                <span style={{color: "#1851A3", fontWeight: '700', textAlign: "center"}}>
                                {step.desc}
                            </span>
                            <span style={{position: 'absolute', left: 'calc(50% - 1em)', top: '2em', zIndex: 50}}>
                                {step.status === 'complete' ?
                                    <svg width="32" height="33" viewBox="0 0 32 33" fill="none"
                                         xmlns="http://www.w3.org/2000/svg">
                                        <rect y="0.775391" width="32" height="32" rx="16" fill="#1851A3"/>
                                        <path
                                            fillRule="evenodd"
                                            clipRule="evenodd"
                                            d="M22.7071 12.0683C23.0976 12.4588 23.0976 13.092 22.7071 13.4825L14.7071 21.4825C14.3166 21.873 13.6834 21.873 13.2929 21.4825L9.29289 17.4825C8.90237 17.092 8.90237 16.4588 9.29289 16.0683C9.68342 15.6778 10.3166 15.6778 10.7071 16.0683L14 19.3612L21.2929 12.0683C21.6834 11.6778 22.3166 11.6778 22.7071 12.0683Z"
                                            fill="white"
                                        />
                                    </svg> : <></>}
                                {step.status === 'current' ?
                                    <svg width="32" height="33" viewBox="0 0 32 33" fill="none"
                                         xmlns="http://www.w3.org/2000/svg">
                                        <rect x="1" y="1.77539" width="30" height="30" rx="15" fill="#EFF6FF"/>
                                        <rect x="1" y="1.77539" width="30" height="30" rx="15" stroke="#1851A3"
                                              strokeWidth="2"/>
                                        <circle cx="16" cy="16.7754" r="5" fill="#1851A3"/>
                                    </svg> : <></>
                                }
                                {step.status === 'upcoming' ?
                                    <svg width="32" height="33" viewBox="0 0 32 33" fill="none"
                                         xmlns="http://www.w3.org/2000/svg">
                                        <rect x="1" y="1.77539" width="30" height="30" rx="15" fill="white"/>
                                        <rect x="1" y="1.77539" width="30" height="30" rx="15" stroke="#D1D5DB"
                                              strokeWidth="2"/>
                                    </svg> : <></>
                                }
                            </span>
                            {
                                index !== steps.length - 1 ?
                                    <span style={{
                                        position: 'absolute',
                                        width: '100%',
                                        left: 'calc(50% + 1em)',
                                        top: 'calc(100% + 0.25em)'
                                    }}>
                                    <hr/>
                                </span>
                                    :
                                    <div></div>
                            }
                            </div>
                        </li>
                  ))}
            </ol>
        </nav>
    </div>);
};

export default NavigateCarInsurance;
